import { Button, type ButtonProps } from "react-bootstrap";
import { MdOutlineDoNotDisturb } from "react-icons/md";

const DeclineButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdOutlineDoNotDisturb /> {children}
  </Button>
);

export default DeclineButton;
